"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const utils_1 = require("./utils");
class ComponentRegistry {
    constructor() {
        this.registry = {};
    }
    // Register synchronous component
    register(component, async) {
        return {
            as: (name) => {
                this.registry[name] = { component, async };
            }
        };
    }
    // Get registered component
    getComponent(name) {
        return this.registry[name];
    }
    suggest(componentName) {
        const suggestions = Object.keys(this.registry)
            .filter((name) => name.includes(componentName) || (0, utils_1.getLevenshteinDistance)(name, componentName) <= 2); // Allow a distance of 2
        return suggestions.map((x, index) => {
            if (index === suggestions.length - 1)
                return '"' + x + '"';
            if (index === suggestions.length - 2)
                return '"' + x + '" or ';
            return '"' + x + '", ';
        }).join('');
    }
}
exports.default = ComponentRegistry;
